import React, { useEffect, useState /* useRef */ } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { getTodayDate } from "../../../../common/Validations";


//API
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import DataTable from "react-data-table-component";


const LoadingAdviceOrderHistoryModal = React.forwardRef((props, ref) => {

  const [isCardVisible1, setCardVisible1] = useState(true);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };


  const [lineItmes, setLineItems] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [viewStatus, setViewStatus] = useState(false);
  const [propsData, setPropsData] = useState();
  // eslint-disable-next-line no-unused-vars
  const [formInputs, setFormInputs] = useState();

 const [getMergedHistory,setMergedHistory]=useState()

 useEffect(() => {
  const mergedOrderHistory = lineItmes
    .filter(item => Array.isArray(item?.orderHistory))
    .flatMap(item => item.orderHistory);

  setMergedHistory(mergedOrderHistory);
}, [lineItmes]); 


  useEffect(() => {
    setPropsData(props?.loadingadvicedata);
  }, [props?.loadingadvicedata]);

  const orderHistoryCol = [
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.materialDescription} </p>
          <p className="m-0 p-0 ">{row?.materialCode} </p>
        </div>
      ),
      width: "250px",
    },
    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.orderQtyLoadConfirm} </p>
          <p className="m-0 p-0 ">{row?.uOM} </p>
        </div>
      ),
      width: "130px",
    },
  
    {
      name: "Date/time",
  
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.loadingDate||"--"} </p>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.loadingTime||"--"} </p>
        </div>
      ),
      width: "160px",
    },
    {
      name: "Godown",
    
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.godownAddress||"--"} </p>
        </div>
      ),
      sortable: true,
      width: "200px",
    },

    {
      name: "Truck No",
   
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.loadingTruckNo||"--"} </p>
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    
    {
      name: "Driver Details",
  
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.transporterDriverName||"--"} </p>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.transporterDriverContact||"--"} </p>
        </div>
      ),
      width: "160px",
    },
    {
      name: "Shipping Addr",
      cell: (row) => (
        <>
          <p>{row?.shippingAddress}</p>
        </>
      ),
      width: "130px",
    },

    {
      name: "Shipping Postal",
      cell: (row) => (
        <>
          <p>{row?.shippingPostalCode}</p>
        </>
      ),
      width: "160px",
    },
    {
      name: "Loading Nr",
      cell: (row) => (
        <>
          <p className="m-0 p-0 pt-1 fw-bold">{row?.loadingAdviceNr}</p>
        </>
      ),
      width: "130px",
    },
    {
      name: "Loading Date",
      cell: (row) => (
        <>
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.loadingDate||"--"} </p>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.loadingTime||"--"} </p>
        </div>
    
        </>
      ),
      width: "130px",
    },
  ];


  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };

    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);


  //call api for paritcular order
  const getMasterData = async () => {
    const docNumber = propsData?.orderSchedulingNr || propsData?.documentNumber;
    if (!docNumber) return;
    let obj = { documentNumber: docNumber };
    setLineItems([]);
    await ItemServiceV2.getOrderBoogkingDetail(obj).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        let itemData = item?.data[0]?.items;
        // Update existing records
        let updateItemData = itemData?.map((item, index) => ({
          ...item,
          orderQtyLoadConfirm: 0,
          loadingDate: getTodayDate(""),
          loadingTime: getCurrentTime(),
        }));

        setLineItems(updateItemData || []);
        setFormInputs(item?.data[0]);
      } else {
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };

  useEffect(() => {
    getMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsData]);

  //get current time
  const getCurrentTime = () => {
    const now = new Date();
    return now.toTimeString().slice(0, 5); // Format HH:mm (24-hour)
  };
  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Loading Advice History - {propsData?.orderSchedulingNr || propsData?.documentNumber}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* Line Items */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility1}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">PD</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">Product </span>
                  <span className="subHeaderTitle">Product details</span>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible1 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <DataTable
                          title=""
                          columns={orderHistoryCol}
                          // data={lineItmes}
                          // data={orderHistories}
                          data={getMergedHistory}
                          // data={getOrderlinItems}
                          // progressPending={orderSchedulingData?.status}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          // paginationTotalRows={orderSchedulingTable.total}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelect}
                          selectableRows
                        />
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
});

export default LoadingAdviceOrderHistoryModal;
